export default {
  init() {
    $('.mfp-video').magnificPopup({
      type: 'iframe',
      iframe: {
        markup: '<div class="mfp-iframe-scaler">' +
          '<div class="mfp-close"></div>' +
          '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
          '</div>',
        patterns: {
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?autoplay=1&amp;rel=0&amp;showinfo=0', // URL that will be set as a source for iframe.
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1',
          },
        },
        srcAction: 'iframe_src',
      },
    });

    function formatCategoriesBar() {
      var button = $('#cat-quick-select');
      var nav = button.parent().find('nav');
      if ($(window).width() > 950) {
        nav.css('display', '');
        button.removeClass('expanded');
      }
    }

    function toggleCategoriesBar(e) {
      e.preventDefault();
      var button = $(this);
      var nav = button.parent().find('nav');
      if (button.hasClass('expanded')) {
        nav.slideUp();
      } else {
        nav.slideDown();
      }
      button.toggleClass('expanded');
    }

    $('#cat-quick-select').click(toggleCategoriesBar);

    $(window).resize(formatCategoriesBar);

    var product_archive = $('ul.sw-product-archive');
    if (product_archive.length) {
      product_archive.find('.product-preview').matchHeight();
      product_archive.find('.woocommerce-loop-product__title').matchHeight();
    }

    if (typeof window.is_name_tags_brand_page !== 'undefined' &&
      window.is_name_tags_brand_page === true) {
      var form = $('form.cart');
      if (form.length) {
        form.submit(function() {
          var textarea = $('textarea#Comments');
          var title = $('h1.entry-title').clone();
          title.find('i').remove();
          textarea.val(textarea.val() + ' --- ' + title.html());
          return true;
        });
      }
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js